<template>
  <div class="py-4" id="content-header">
    <b-breadcrumb class="mb-0 p-0">
      <b-breadcrumb-item v-for="(item, index) in items" :key="index" active>{{
        item
      }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="row">
      <h1 class="h4 pt-2 col-sm col-12">{{ title }}</h1>
      <div
        class="col-sm col-12"
        v-if="
          page_name != '汽車品牌' &&
            page_name != '零件品牌' &&
            page_name != '零件分類' &&
            page_name != '購物須知' &&
            page_name != '該頁無法顯示'
        "
      >
        <b-input-group class="mb-2 ml-auto" id="search">
          <b-input-group-prepend is-text>
            <b-button
              @click="onSearch"
              variant="link"
              class="p-0 text-secondary"
            >
              <b-icon-search></b-icon-search>
            </b-button>
          </b-input-group-prepend>
          <b-form-input
            v-model="search"
            :placeholder="search_placeholder"
          ></b-form-input>
          <b-button-close
            class="pr-2"
            v-if="search"
            @click="clearFilter"
          ></b-button-close>
        </b-input-group>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#content-header {
  background-color: #fff;
  padding-right: $content_x_padding;
  padding-left: $content_x_padding;
  @include media-breakpoint-down(sm) {
    padding-right: $content_x_padding-sm;
    padding-left: $content_x_padding-sm;
  }
}
.breadcrumb {
  background-color: transparent;
  &-item {
    font-size: 14px;
  }
}
#search {
  max-width: 300px;
  border-bottom: 1px solid #bdbdbd;
  @include media-breakpoint-down(xs) {
    border: 1px solid #bdbdbd;
    max-width: 100%;
    margin-top: 20px;
  }
  .input-group-text {
    background-color: transparent;
    border: none;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>

<script>
export default {
  props: ["page_name"],
  data() {
    return {
      title: this.page_name,
      search: null
    };
  },
  computed: {
    items() {
      switch (this.page_name) {
        case "汽車品牌":
        case "零件分類":
        case "零件品牌":
          return ["首頁", "分類管理", this.page_name];
        default:
          return ["首頁", this.page_name];
      }
    },
    search_placeholder() {
      switch (this.page_name) {
        case "廠商帳號管理":
          return "搜尋廠商名稱";
        case "會員列表":
          return "搜尋會員名稱";
        default:
          return "搜尋";
      }
    }
  },
  watch: {},
  methods: {
    clearFilter() {
      this.search = null;
      this.$router
        .push({
          query: null
        })
        .catch(err => {
          err;
        });
    },
    onSearch() {
      if (this.search) {
        if (this.$route.query.search !== this.search) {
          this.$router
            .push({
              query: { search: this.search }
            })
            .catch(err => {
              err;
            });
        }
      } else {
        this.$router
          .push({
            query: null
          })
          .catch(err => {
            err;
          });
      }
    }
  },
  mounted() {
    this.search = this.$route.query.search;
  }
};
</script>
